const ShippingItem = props => {

	let priceCopy = '$0';
	let shippingHeaderCopy = 'Free shipping';
	
	if (props.hasLocalPickup) shippingHeaderCopy = 'Local pickup';
	if (props.price) {
		shippingHeaderCopy ='Standard shipping';
		priceCopy = `$${props.price}`;
	}

	return (
		<div className='d-flex justify-content-between align-items-center mb-4'>
			<p className='lead mb-0'>{shippingHeaderCopy}</p>
			<p className='lead mb-0'>{priceCopy}</p>
		</div>
	);

}

export default ShippingItem;